export { default as store } from './store'
export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/employee/record/specialities/index.js